import React from 'react';
import { ButtonField, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup, ButtonGroupItem } from '@wk/components-react16';
import GaugeChart from 'react-gauge-chart';

const ConfirmPromptScore = ({ data }: any) => {
    const { isOpenConfirmScore, setIsOpenConfirmScore, setIsOpenConfirmScoreQuestion, promptCategoryScore } = data;

    const improvePromptScore = () => {
        setIsOpenConfirmScore(false);
        setIsOpenConfirmScoreQuestion(true);
    }

    const colorPalette: any = [
        "#F59A0E",
        "#353535",
        "#AF78dA",
        "#E5202E",
        "#85BC20"
    ];

    const getCategoryColor = (index: number) => {
        return colorPalette[index % colorPalette.length];
    };

    const safeCategoryScores = Array.isArray(promptCategoryScore) ? promptCategoryScore : [];
    const maxScore = safeCategoryScores.length * 5;
    const totalScore = Number(
        safeCategoryScores
            .reduce((accumulator: number, current: any) => accumulator + (Number(current?.score) || 0), 0)
            .toFixed(2)
    );
    const percent = maxScore > 0 ? Math.min(Math.max(totalScore / maxScore, 0), 1) : 0;

    return (
        <div className='custom-modal'>
            <Modal
                isOpen={isOpenConfirmScore}
                srLabelledBy={'modal-id-confirm-score'}
                srDescribedBy={'modal-id-confirm-score'}
                width={'450px'}>
                <ModalHeader
                    titleId={'modal-id-confirm-score'}
                    isFullscreenButtonVisible={false}
                    onUserRequest={() => setIsOpenConfirmScore(false)}>
                    Prompt Score <small className='wk-primary-blue-shade2 wk-size-2'>({totalScore}/{maxScore})</small>
                </ModalHeader>
                <ModalBody descriptionId="modal-id-confirm-score">
                    <div className='wk-grid-page-container p-0'>
                        <GaugeChart style={{width: '250px', margin: '0 auto'}}
                            id="gauge-chart4"
                            nrOfLevels={3}
                            colors={["red", "orange", "green"]}
                            arcWidth={0.3}
                            arcsLength={[0.3, 0.5, 0.2]}
                            percent={percent}
                            textColor={'black'}
                            //hideText={true}
                        />
                        <div className="wk-grid mb-10">
                            {safeCategoryScores.length > 0 ? safeCategoryScores.map((item: any, index: number) => {
                                const sategoryColor = getCategoryColor(index);
                                return (
                                    <div className={`wk-column-6 ${index % 2 === 0 ? 'pr-10' : 'pl-10'}`} key={index}>
                                        <div className="p-10 wk-card-container mb-0 rounded-3 border box-shadow">
                                            <div className="d-flex">
                                                <div
                                                    className={`card-title${index % 2 === 0 ? '2' : '1'}`}
                                                    style={{ color: sategoryColor }}
                                                >
                                                    {item.categoryScoreTypeName}
                                                </div>
                                                <div className="ms-auto">{item.score}/5</div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            }) : null}
                        </div>
                        <div className='pt-10 pb-10'>
                            Enhance your score with Content Rocket—click below to get started!
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <ButtonGroup mode="static">
                        <ButtonGroupItem slot="buttonGroupItem">
                            <ButtonField mode={'ghost'}>
                                <button
                                    className='mr-10'
                                    type="button"
                                    id="cancel"
                                    onClick={() => setIsOpenConfirmScore(false)}>
                                    Skip
                                </button>
                            </ButtonField>
                            <ButtonField>
                                <button
                                    type="button"
                                    id="defaultClose"
                                    onClick={() => improvePromptScore()}>
                                    Enhance Score
                                </button>
                            </ButtonField>
                        </ButtonGroupItem>
                    </ButtonGroup>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default ConfirmPromptScore;
